/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiEvent
 */
export interface ApiEvent {
    /**
     * 
     * @type {number}
     * @memberof ApiEvent
     */
    id: number;
    /**
     * 
     * @type {ApiEventStatusEnum}
     * @memberof ApiEvent
     */
    status: ApiEventStatusEnum;
    /**
     * 
     * @type {ApiEventTypeEnum}
     * @memberof ApiEvent
     */
    type: ApiEventTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiEventStatusEnum {
    NEW = 'NEW',
    PROCESSED = 'PROCESSED'
}
/**
* @export
* @enum {string}
*/
export enum ApiEventTypeEnum {
    PERSON_CREATED = 'PERSON_CREATED',
    PERSON_UPDATED = 'PERSON_UPDATED',
    TRANSACTION_CREATED = 'TRANSACTION_CREATED',
    ALERT_CREATED = 'ALERT_CREATED',
    PERSON_STATUS_UPDATED = 'PERSON_STATUS_UPDATED',
    SANCTION_CHECK = 'SANCTION_CHECK',
    FILTER_NEW_ALERTS = 'FILTER_NEW_ALERTS',
    SANCTION_CHECK_BATCH = 'SANCTION_CHECK_BATCH'
}


/**
 * Check if a given object implements the ApiEvent interface.
 */
export function instanceOfApiEvent(value: object): value is ApiEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ApiEventFromJSON(json: any): ApiEvent {
    return ApiEventFromJSONTyped(json, false);
}

export function ApiEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'type': json['type'],
    };
}

export function ApiEventToJSON(json: any): ApiEvent {
    return ApiEventToJSONTyped(json, false);
}

export function ApiEventToJSONTyped(value?: ApiEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'type': value['type'],
    };
}

